import React from 'react';
import classnames from 'classnames';
import s from './Placeholder.scss';
const Placeholder = ({ className, width, height })=>{
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames(s['root'], className)
    });
};
Placeholder.displayName = 'Placeholder';
export default Placeholder;
